import { useSyncExternalStore } from "react";

/** The widest a desktop can give the panel and still leave the page a column: 720 plus the rail and a page. */
const ROOM = "(min-width: 1280px)";

let pinned = false;
let wanting = 0;
const listeners = new Set<() => void>();

const tell = () => {
  for (const l of listeners) l();
};

const room = () =>
  typeof window !== "undefined" &&
  typeof window.matchMedia === "function" &&
  window.matchMedia(ROOM).matches;

function subscribe(onChange: () => void) {
  listeners.add(onChange);
  const list =
    typeof window !== "undefined" && window.matchMedia ? window.matchMedia(ROOM) : null;
  list?.addEventListener("change", onChange);
  return () => {
    listeners.delete(onChange);
    list?.removeEventListener("change", onChange);
  };
}

/** The person's own choice, from the menu's Wider panel. */
export function pinDjinnWide(on: boolean) {
  if (pinned === on) return;
  pinned = on;
  tell();
}

/** A card that wants room (three ways side by side) asks for it; the returned function gives it back. */
export function wantDjinnWide(): () => void {
  wanting += 1;
  tell();
  let given = false;
  return () => {
    if (given) return;
    given = true;
    wanting -= 1;
    tell();
  };
}

/** True while the panel is 720 wide: pinned, or a card asked, and the window has room. */
export function useDjinnWide(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => (pinned || wanting > 0) && room(),
    () => false,
  );
}

/** True when the window has room for the wide panel at all. */
export function useDjinnRoom(): boolean {
  return useSyncExternalStore(subscribe, room, () => false);
}

/** True while the person has pinned the panel wide. */
export function useDjinnPinned(): boolean {
  return useSyncExternalStore(
    subscribe,
    () => pinned,
    () => false,
  );
}

/** Forgets everything: for a test, and for the moment the panel closes. */
export function resetDjinnWide() {
  pinned = false;
  wanting = 0;
  tell();
}
